import { AuditListItemController } from './audit-list-item.controller'

function auditListItem () {
  return {
    restrict: 'E',
    scope: {
      audit: '<'
    },
    templateUrl: '/audit/directives/audit-list-item/audit-list-item-directive.html?$$REVISION$$',
    controller: AuditListItemController
  }
}

export { auditListItem }
